import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Signup from "./pages/Signup";
import Login from "./pages/Login";
import Pricing from "./pages/Pricing";
import ApiDocs from "./pages/ApiDocs";
import LegalDocs from "./pages/LegalDocs";
import Profile from "./pages/Profile";
import ForgetPass from "./pages/ForgetPass";
import ChangePass from "./pages/ChangePass";
import EnhancedResearchDashboard from "./pages/EnhancedResearchDashboard";
import VerifyEmail from "./pages/VerifyEmail";
import AdminLogin from "./pages/AdminLogin";
import AdminDashboard from "./pages/admin/AdminDashboard";
import AdminUserManagement from "./pages/admin/AdminUserManagement";
import AdminFieldAccess from "./pages/admin/AdminFieldAccess";
import AdminPubMedIngest from "./pages/admin/AdminPubMedIngest";
import AdminLogs from "./pages/admin/AdminLogs";
import ProtectedRoute from "./components/common/ProtectedRoute";
import PublicRoute from "./components/common/PublicRoute";
import DataViewPage from "./pages/DataViewPage";

function App() {
  return (
    <>
     <Router>
      <Routes>
        <Route path="/" element={<PublicRoute><Login /></PublicRoute>} />
        <Route path="/signup" element={<PublicRoute><Signup /></PublicRoute>} />
        <Route path="/login" element={<PublicRoute><Login /></PublicRoute>} />
        <Route path="/pricing" element={<PublicRoute><Pricing /></PublicRoute>} />
        <Route path="/api-docs" element={<ApiDocs />} />
        <Route path="/legal-docs" element={<LegalDocs />} />
        <Route
          path="/profile"
          element={
            <ProtectedRoute requiredRole="researcher">
               <Profile />
            </ProtectedRoute>
          }
          
        />
        <Route path="/forgot-password" element={
          <ProtectedRoute requiredRole="researcher">
             <ForgetPass />
            </ProtectedRoute>
          } 
          />
        <Route path="/change-password"
             element={<ProtectedRoute requiredRole="researcher">
             <ChangePass />
            </ProtectedRoute>}
            />

        <Route path="/verify-email" 
        element={<PublicRoute><VerifyEmail /></PublicRoute>}
         />

        <Route
          path="/research"
          element={
            <ProtectedRoute requiredRole="researcher">
              <EnhancedResearchDashboard />
            </ProtectedRoute>
          }
        />
        <Route
          path="/research/data-view"
          element={
            <ProtectedRoute requiredRole="researcher">
              <DataViewPage />
            </ProtectedRoute>
          }
        />
        
        {/* Admin Routes */}
        <Route path="/admin/login" element={<PublicRoute><AdminLogin /></PublicRoute>} />
        <Route
          path="/admin/dashboard"
          element={
            <ProtectedRoute requiredRole="admin">
              <AdminDashboard />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/users"
          element={
            <ProtectedRoute requiredRole="admin">
              <AdminUserManagement />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/data-view"
          element={
            <ProtectedRoute requiredRole="admin">
              <DataViewPage mode="admin" />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/pubmed-ingest"
          element={
            <ProtectedRoute requiredRole="admin">
              <AdminPubMedIngest />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/field-access"
          element={
            <ProtectedRoute requiredRole="admin">
              <AdminFieldAccess />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/logs"
          element={
            <ProtectedRoute requiredRole="admin">
              <AdminLogs />
            </ProtectedRoute>
          }
        />
      </Routes>
    </Router>
    </>
  );
}

export default App;
